/**
 * ActivationPaymentsMiscCtrl controller
 */

import { remove, add, getId } from 'app/helpers/entity'

/**
 * ActivationPaymentsMiscCtrl controller
 *
 * @class ActivationPaymentsMiscCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
 */
/* @ngInject */
export default function ActivationPaymentsMiscCtrl (scope, subscr, extra, accessories) {
  const vm = this

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
   * @type {Object}
   */
  vm.extra = extra

  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
   * @type {Object}
   */
  vm.scope = scope

  /**
   * Return blank payment request
   * When user changes payment type, for exmple, we need new blank payment request, without old data
   *
   * @function
   */
  const getBlankPaymentRequest = (defaults = {}) => ({
    addOns: [],
    ...defaults
  })

  vm.filterAccessories = function (accessory) {
    return !vm.payment.addOns.length || vm.payment.addOns[0].currency.id === accessory.currency.id
  }

  /**
   * Blank for PaymentRequest
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
   * @type {Object}
   */
  const payment = vm.payment = getBlankPaymentRequest()

  vm.addOns = (angular.copy(accessories) || []) // .filter(a => a.currency.id === vm.subscription.currency.id)

  /**
   * Actions on change form fields
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsMiscCtrl
   * @type {Object}
   */
  vm.change = {

    /**
     * Add addon to payment request
     */
    addAddOn (addon) {
      add(payment.addOns)(
        remove(vm.addOns)(addon)()[0]
      )()
      vm.addon = undefined
      scope.calculate()
    },

    /**
     * Remove addons from payment request
     */
    removeAddOn (addon) {
      add(vm.addOns)(
        remove(payment.addOns)(addon)()[0]
      )()
      scope.calculate()
    }
  }

  /*
   * Get part of payment from child view
   */
  scope.getChildPayment = () => ({ ...payment, accessoryIds: payment.addOns.map(getId) })

  scope.calculate()
}
